import { render, staticRenderFns } from "./agreementEdit.vue?vue&type=template&id=0dad5bcf"
import script from "./agreementEdit.vue?vue&type=script&lang=js"
export * from "./agreementEdit.vue?vue&type=script&lang=js"
import style0 from "./agreementEdit.vue?vue&type=style&index=0&id=0dad5bcf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports